import { button_dark_theme } from 'framework/button/constants';
import { calendar_dark_theme } from 'framework/calendar/constants';
import { checkbox_dark_theme } from 'framework/checkbox/constants';
import { icon_dark_theme } from 'framework/Icon/constants';
import { modal_dark_theme } from 'framework/modal/hooks/constants';
import { options_dark_theme } from 'framework/Options/constants';
import { pill_dark_theme } from 'framework/Pill/constants';
import { popover_dark_theme } from 'framework/popover/hooks/constants';
import { switch_dark_theme } from 'framework/Switch/constants';

import { chip_dark_theme } from '../../chip/constants';
import { field_dark_theme } from '../../field/constants';
import { grid_dark_theme } from '../../Grid/hooks/constants';
import { Theme } from '../types';

import { font_dark_theme } from './font';

export const dark: Theme = {
  font: font_dark_theme,
  field: field_dark_theme,
  pill: pill_dark_theme,
  options: options_dark_theme,
  grid: grid_dark_theme,
  switch: switch_dark_theme,
  calendar: calendar_dark_theme,
  checkbox: checkbox_dark_theme,
  chip: chip_dark_theme,
  icon: icon_dark_theme,
  button: button_dark_theme,
  modal: modal_dark_theme,
  popover: popover_dark_theme,
};
